module.exports = __webpack_public_path__ + "159936fe2c06919080be72bbc127e03a.png";